import { createSlice } from "@reduxjs/toolkit"

const base = {
	callDate: "",
	passwordStrenght: null,
	credential: null,
	categoryCompartimentation: null,
	passwordPolicy: null,
}

const dashboardLPSlice = createSlice({
	name: "dashboardLP",
	initialState: {
		productLoading: true,
		loading: true,
		data: null,
		openList: null,
		infoSelect: [],
		valueSelect: null,
		showList: [],
		fullList: [],
		layoutNavIndex: 0,
		boardNavIndex: 0,
		selectIndex: null,
		selectDataComponentUse: [],
		oldDataComponantUse: [],
		selectMetricComponent: null,
		selectSagaList: [],
		paginLoading: false,
		actionLoading: false,
		pagingLimit: true,
	},
	reducers: {
		init: (state) => {
			state.data = base
			state.productLoading = true
			state.loading = false
			state.openList = null
			state.infoSelect = []
			state.layoutNavIndex = 0
			state.boardNavIndex = 0
			state.showList = []
			state.fullList = []
			state.selectDataComponentUse = []
			state.oldDataComponantUse = []
			state.selectMetricComponent = null
			state.selectSagaList = []
			state.paginLoading = false
			state.actionLoading = false
			state.valueSelect = null
			state.selectIndex = null
			state.pagingLimit = true
		},
		setLoader: (state, action) => {
			const rightPayload = [
				"callDate",
				"passwordStrenght",
				"credential",
				"categoryCompartimentation",
				"passwordPolicy",
			]
			let payloadIsOk = false

			if (action.payload?.isLocal) {
				if (action.payload?.dataLocalStorage) {
					Object.keys(action.payload?.dataLocalStorage).forEach(
						(item) => {
							const itemIsInRightPayload = rightPayload.find(
								(searchedItem) => searchedItem === item,
							)

							if (itemIsInRightPayload) payloadIsOk = true
						},
					)
				}

				if (!action.payload) state.data = null
				else if (payloadIsOk) {
					state.data = {
						...state.data,
						...action.payload?.dataLocalStorage,
					}

					localStorage.setItem(
						"dashboardLP",
						JSON.stringify(state.data),
					)
				}
			} else {
				if (action.payload) {
					if (rightPayload.includes(action.payload.key))
						payloadIsOk = true
				}

				if (!action.payload) state.data = null
				else if (payloadIsOk) {
					state.data.callDate = action.payload?.callDate
					state.data[action.payload?.key] = action.payload?.value

					localStorage.setItem(
						"dashboardLP",
						JSON.stringify(state.data),
					)
				}
			}
		},
		setProductLoading: (state, action) => {
			if (action.payload) state.productLoading = action.payload
			else state.productLoading = false
		},
		toggleLoading: (state, action) => {
			if (!action.payload) state.loading = false
			else state.loading = action.payload
		},
		setActionLoading: (state, action) => {
			if (!action.payload) state.actionLoading = null
			else state.actionLoading = action.payload
		},
		paginLoading: (state, action) => {
			if (!action.payload) state.paginLoading = false
			else state.paginLoading = action.payload
		},
		setLAR: (state, action) => {
			if (!action.payload) state.lastActionResult = null
			else state.lastActionResult = action.payload
		},
		setOpenList: (state, action) => {
			if (!action.payload) state.openList = null
			else state.openList = action.payload
		},
		setInfoSelect: (state, action) => {
			if (!action.payload) state.infoSelect = []
			else state.infoSelect = action.payload
		},
		setValueSelect: (state, action) => {
			if (!action.payload) state.valueSelect = null
			else state.valueSelect = action.payload
		},
		setLayoutNavIndex: (state, action) => {
			if (!action.payload) state.layoutNavIndex = 0
			else state.layoutNavIndex = action.payload
		},
		setBoardNavIndex: (state, action) => {
			if (!action.payload) state.boardNavIndex = 0
			else state.boardNavIndex = action.payload
		},
		setShowList: (state, action) => {
			if (!action.payload) state.showList = []
			else state.showList = action.payload
		},
		setFullList: (state, action) => {
			if (!action.payload) state.fullList = []
			else state.fullList = action.payload
		},
		setSelectDataComponentUse: (state, action) => {
			if (!action.payload) state.selectDataComponentUse = []
			else state.selectDataComponentUse = action.payload
		},
		setOldDataComponantUse: (state, action) => {
			state.oldDataComponantUse = action.payload
		},
		setSelectMetricComponent: (state, action) => {
			if (!action.payload && action.payload !== 0) {
				state.selectMetricComponent = null
			} else state.selectMetricComponent = action.payload
		},
		setSelectSagaList: (state, action) => {
			if (!action.payload) state.selectSagaList = []
			else state.selectSagaList = action.payload
		},
		setSelectIndex: (state, action) => {
			if (!action.payload && action.payload !== 0)
				state.selectIndex = null
			else state.selectIndex = action.payload
		},
		setPagingLimit: (state, action) => {
			state.pagingLimit = action.payload
		},
	},
})

export const { init } = dashboardLPSlice.actions

export default dashboardLPSlice.reducer
